export default {
      id: "btn_question-usage",
      viewBox: "0 0 25 25",
      url: __webpack_public_path__ + "sprite.svg#btn_question",
      toString: function () {
        return this.url;
      }
    }